"use client";
import { MollerFont } from "./moller/index.js";
import { BilholdFont } from "./bilhold/index.js";
import { SkodaFont } from "./skoda/index.js";
import { GumpenFont } from "./gumpen/index.js";
import { VWFont } from "./VW/index.js";
import { DahlesFont } from "./dahles/index.js";
import { AutoriaFont } from "./autoria/index.js";
import { AudiFont } from "./audi/index.js";
import { CupraFont } from "./cupra/index.js";
export {
  AudiFont,
  AutoriaFont,
  BilholdFont,
  CupraFont,
  DahlesFont,
  GumpenFont,
  MollerFont,
  SkodaFont,
  VWFont
};
